import * as React from 'react'

import {
  Box,
  Circle,
  type CircleVariantsType,
  Tag,
  Text,
} from '@factorialco/deprecated-design-system'

interface Props {
  label: string
  color?: string
  type?: CircleVariantsType
  outline?: boolean
}

const LegendItem = ({ label, color, type, outline }: Props) => {
  return (
    <Box minWidth="none" padding="s4">
      <Tag>
        <Box flexDirection="row" alignItems="center" minWidth="none" gap="s8">
          <Circle color={color} type={type} outline={outline} size={10} />
          <Box flexDirection="row" minWidth="none">
            {label && (
              <Text.Normal size="200" color="grey800" ellipsis>
                {label}
              </Text.Normal>
            )}
          </Box>
        </Box>
      </Tag>
    </Box>
  )
}

export default LegendItem
